import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useActivation } from "./ActivationContext";
import ActivationTour from "./ActivationTour";
import ActivationCoach from "./ActivationCoach";
import { useIsMobile } from "../hooks/useMediaQuery";
import s from "./activation.module.css";

const DOCK = "340px";

function useIsNarrow(breakpoint = 900) {
  const [narrow, setNarrow] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false,
  );
  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth <= breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return narrow;
}

/** Dock for real-club activation path (hidden while training sandbox is on). */
export default function ActivationChrome() {
  const { visible, collapsed, tourPaused, resumeTour, progressCount, totalSteps } =
    useActivation();
  const narrow = useIsNarrow();
  const isMobile = useIsMobile(768);

  useEffect(() => {
    const root = document.documentElement;
    if (!visible) {
      root.classList.remove("baysport-act");
      root.style.removeProperty("--baysport-act-right");
      return undefined;
    }
    root.classList.add("baysport-act");
    root.style.setProperty(
      "--baysport-act-right",
      narrow || collapsed || isMobile ? "0px" : DOCK,
    );
    return () => {
      root.classList.remove("baysport-act");
      root.style.removeProperty("--baysport-act-right");
    };
  }, [visible, collapsed, narrow, isMobile]);

  if (!visible) return null;

  return createPortal(
    <>
      <ActivationTour />
      <ActivationCoach />
      {tourPaused ? (
        <button
          type="button"
          className={s.actResumeFab}
          onClick={() => resumeTour()}
        >
          Продолжить · {Math.min(progressCount + 1, totalSteps)}/{totalSteps}
        </button>
      ) : null}
    </>,
    document.body,
  );
}
